import { FC } from 'react';
import Source1 from './assets/source1.svg';
import Source2 from './assets/source2.svg';
import Source3 from './assets/source3.svg';
import Source4 from './assets/source4.svg';
import Source5 from './assets/source5.svg';
import Source6 from './assets/source6.svg';
import Source7 from './assets/source7.svg';
import Source8 from './assets/source8.svg';
import Source9 from './assets/source9.svg';
import Source10 from './assets/source10.svg';
import useReflowClick from '~/utils/use-reflow-click';
import { ClickPosition } from '~/utils/click-position';
import { usePageActive } from '~/utils/active/use-page-active';
import { useLocation, useNavigate } from '@remix-run/react';
import { DETAIL_POST_MODAL_NAME, EArticleClass } from 'shared/models';
import { ModuleType } from '~/utils/module-type';
import { ExtractAtomValue, useAtomValue } from 'jotai';
import { $InstalledRelatedApp } from '@lemon8/web-app-shared/atom';
import { $CurrentExperienceAnswerAsAvailable } from '../../atoms';

import './style.scss';

export const SourceIndex: FC<{ index: number }> = ({ index }) => {
  const active = usePageActive();
  const navigate = useNavigate();
  const location = useLocation();

  const { articleInfoList } = useAtomValue($CurrentExperienceAnswerAsAvailable);

  const articleInfo = articleInfoList[index];

  const { groupId, author, articleClass } = articleInfo;

  const isOldUser = !(['pending', null] as ExtractAtomValue<typeof $InstalledRelatedApp>[]).includes(
    useAtomValue($InstalledRelatedApp),
  );

  const handleClickArticle = useReflowClick(
    {
      clickEvent: (_, bundle) => ({
        ...bundle,
        current_page_module: ModuleType.experience_content,
        current_position: ClickPosition.source_article_index,
        group_id: groupId,
        page_click_id: groupId,
        rank: index,
      }),
      finallyBehavior: () => {
        if (!isOldUser) {
          navigate(
            {
              pathname: '.',
              search: location.search, // must keep search otherwise search will disappear
            },
            {
              state: { enterName: DETAIL_POST_MODAL_NAME, gid: groupId, authorId: author.userId },
            },
          ); // push state but not change url
        } else {
          active({
            schemaOption: {
              pageType: articleClass === EArticleClass.VIDEO ? 'video' : 'article',
              groupId,
              authorId: author.userId,
            },
            ampExtra: {
              enter_position: ClickPosition.related_post,
            },
          });
        }
      },
    },
    [active, groupId, articleClass, author],
  );

  let sourceImg = null;
  switch (index) {
    case 0:
      sourceImg = <Source1 />;
      break;
    case 1:
      sourceImg = <Source2 />;
      break;
    case 2:
      sourceImg = <Source3 />;
      break;
    case 3:
      sourceImg = <Source4 />;
      break;
    case 4:
      sourceImg = <Source5 />;
      break;
    case 5:
      sourceImg = <Source6 />;
      break;
    case 6:
      sourceImg = <Source7 />;
      break;
    case 7:
      sourceImg = <Source8 />;
      break;
    case 8:
      sourceImg = <Source9 />;
      break;
    case 9:
      sourceImg = <Source10 />;
      break;
    default:
      sourceImg = null;
  }
  return (
    sourceImg && (
      <div className="source-index" onClick={handleClickArticle}>
        {sourceImg}
      </div>
    )
  );
};
